import React from "react";
import { Card, Button } from "react-bootstrap";
import Eye from "../../assets/images/icons/Eye.svg";
import { formatToUSDate } from "../../utils/dateFormat";
import { useNavigate } from "react-router-dom";

function EventTicketCard({ event }) {
  const navigate = useNavigate();
  return (
    <Card
      className="mb-3 shadow-sm border-0 rounded-4"
      onClick={() => {
        navigate(`/events/${event._id}`);
      }}
    >
      <Card.Body className="d-flex gap-3 align-items-center">
        {/* Event Image */}
        <img
          src={event.image}
          alt={event.title}
          style={{
            width: 120,
            height: 80,
            objectFit: "cover",
            borderRadius: "10px",
          }}
        />

        <div className="flex-grow-1">
          <h5 className="mb-1">{event.title}</h5>

          <div className="text-muted small">
            <div>{formatToUSDate(event.start_date.split("T")[0])}</div>
            <div>{event.venue}</div>
          </div>
        </div>

        {/* Tickets Count */}
        <Button variant="warning" className="rounded-5 px-3">
          {event.tickets} Tickets
        </Button>

        {/* View Icon */}
        <img
          src={Eye}
          alt="eye "
          size={22}
          className="text-secondary"
          style={{ cursor: "pointer" }}
        />
      </Card.Body>
    </Card>
  );
}

export default EventTicketCard;
